import {Orientation, Dependencies} from 'services/screen';
import {sizeOf} from '../sizeOf';

export function orientationOf(di: Dependencies = {}): Orientation {
  const {width, height} = sizeOf(di);
  if (width >= height) return 'landscape';
  return 'portrait';
}
